module.exports = __webpack_public_path__ + "static/media/hook-n-ladder-poster.6e03c2d3.png";